import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { v4 as uuidv4 } from "uuid";
import CookieConsentBanner from "./components/CookieConsent/CookieConsentBanner";
import OauthFlow from "./components/OauthConsent/OauthFlow";
import Signup from "./components/Signup";
import { Env } from "./Constants";
import "./input.css";
import { readOauthRequest } from "./utils/oauthState";

Sentry.init({
  enabled: import.meta.env.PROD,
  environment: Env,
  dsn: "https://dbf869e410da8c55c66db359f2b15677@o214858.ingest.sentry.io/4506540244402176",
  ignoreErrors: [/Object Not Found Matching Id/],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const challengeId = uuidv4();
const oauthRequest = readOauthRequest(window.location.search);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    {oauthRequest ? (
      <OauthFlow oauthRequest={oauthRequest} challengeId={challengeId} />
    ) : (
      <Signup key={"signup"} challengeId={challengeId} />
    )}
    <CookieConsentBanner />
  </>,
);
